import {branch, renderComponent} from 'recompose'
import LoadingPlaceHolder from '../components/LoadingPlaceHolder'

export const withLoading = branch(props => props.data.loading, renderComponent(LoadingPlaceHolder))
